// Export for use in other modules
module.exports = function () {
    /**
     * Equalizes the height of elements on the same visual row based on a CSS selector.
     * @param {string} selector - CSS selector for the elements to equalize
     */
    function equalizeHeadings(selector) {
        const items = document.querySelectorAll(selector);

        // Reset all heights before calculation
        items.forEach(el => {
            el.style.removeProperty('height');
        });

        // Group elements into visual rows
        let rows = [];
        let currentTop = null;

        items.forEach(el => {
            const top = el.getBoundingClientRect().top;

            if (currentTop === null || Math.abs(top - currentTop) < 5) {
                if (rows.length === 0) rows.push([]);
                rows[rows.length - 1].push(el);
                currentTop = top;
            } else {
                rows.push([el]);
                currentTop = top;
            }
        });

        // Set the height of all elements in the row to the tallest one
        rows.forEach(row => {
            let maxHeight = 0;
            row.forEach(el => {
                maxHeight = Math.max(maxHeight, el.offsetHeight);
            });
            row.forEach(el => {
                el.style.height = `${maxHeight}px`;
            });
        });
    }

    /**
     * Wrapper that applies equalization to a predefined selector.
     */
    equalizeHeadings('.column-list__item .column-list__item__title'); // Change selector if needed
};
